import Logo from "../assets/Logo.png";
import WaterIcon from "../assets/WaterIcon.png";

type Props = {};

const Page3 = (props: Props) => {
  return (
    <div className="flex justify-center items-center w-screen h-screen  bg-[#181818]">
      <div className="w-[384px] h-[256px] bg-[#181818] flex flex-col items-center ">
        <h1 className="text-3xl font-semibold text-white mt-6 text-center mb-8">
          Fresh water is 0.002% on Earth
        </h1>
        <div className="grid grid-cols-3 w-full gap-16 mt-6">
          <div className="flex justify-center items-center">
            <img src={WaterIcon} className="w-[4.5rem] h-[4.5rem]" />
          </div>
          <div className="flex flex-col w-96 justify-center  ">
            <h1 className="text-white -ml-[4rem] text-3xl font-semibold ">
              SAVE WATER
            </h1>
            <h1 className="text-white -ml-9 text-3xl font-semibold ">
              SAVE EARTH
            </h1>
          </div>
          <div className="flex justify-center items-center ">
            <img src={Logo} className=" w-18 h-16 " />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Page3;
